import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { _T } from 'appI18n';
import useStyles from './styles';
import { TouristPicker, TouristPickerWithPlace } from './TouristPicker';
export function TouristPickerDialog(props) {
    const [adultCount, setAdultCount] = useState(props.adultCount);
    const [childAges, setChildAges] = useState(props.childAges);
    const classes = useStyles();
    const handleApply = () => {
        if (props.adultCount != adultCount || childAges.join(' ') != props.childAges.join(' '))
            props.onChange(adultCount, childAges);
        props.onClose();
    };
    const handleClose = () => props.onClose();
    const handleChange = (adultCount, childAges) => {
        setAdultCount(adultCount);
        setChildAges(childAges);
    };
    return (React.createElement(Dialog, { open: props.open, onClose: handleClose, "aria-labelledby": "change-tourists-dialog", style: props.isFrame ? {
            height: 'fit-content'
        } : undefined },
        React.createElement(DialogTitle, { id: "change-tourists-dialog" }, _T.COMMON_CHANGE_TOURISTS),
        React.createElement(DialogContent, { className: classes.dialog },
            React.createElement(TouristPicker, { adultCount: adultCount, childAges: childAges, onChange: handleChange })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: handleClose, color: "primary" }, _T.COMMON_ACTION_CANCEL),
            React.createElement(Button, { onClick: handleApply, color: "primary" }, _T.COMMON_ACTION_APPLY))));
}
export function TouristPickerWithPlaceDialog(props) {
    const [adultCount, setAdultCount] = useState(props.adultCount);
    const [childAges, setChildAges] = useState(props.childAges.map(c => (Object.assign({}, c))));
    const classes = useStyles();
    const handleApply = () => {
        if (props.adultCount != adultCount || childAges.map(c => c.withPlace ? `${c.age}+` : c.age).join(' ') != props.childAges.map(c => c.withPlace ? `${c.age}+` : c.age).join(' '))
            props.onChange(adultCount, childAges);
        props.onClose();
    };
    const handleClose = () => props.onClose();
    const handleChange = (adultCount, childAges) => {
        setAdultCount(adultCount);
        setChildAges(childAges);
    };
    return (React.createElement(Dialog, { open: props.open, onClose: handleClose, "aria-labelledby": "change-tourists-dialog" },
        React.createElement(DialogTitle, { id: "change-tourists-dialog" }, _T.COMMON_CHANGE_TOURISTS),
        React.createElement(DialogContent, { className: classes.dialog },
            React.createElement(TouristPickerWithPlace, { adultCount: adultCount, childAges: childAges, onChange: handleChange })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: handleClose, color: "primary" }, _T.COMMON_ACTION_CANCEL),
            React.createElement(Button, { onClick: handleApply, color: "primary" }, _T.COMMON_ACTION_APPLY))));
}
